const STEPS = ['tickets', 'attendees', 'payment'];

export default function Progress({ current, t }) {
  const currentIndex = STEPS.indexOf(current);
  return (
    <ol
      className='site-progress'
      aria-label={t('progress.label')}
    >
      {STEPS.map((step, index) => {
        const state =
          index < currentIndex ? 'is-done' : index === currentIndex ? 'is-current' : '';
        return (
          <li
            key={step}
            className={`site-progress__item ${state}`}
            aria-current={index === currentIndex ? 'step' : undefined}
          >
            {t(`progress.${step}`)}
          </li>
        );
      })}
    </ol>
  );
}
